export default "__VITE_ASSET__eeb51b28__"